import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setRole } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Home, Building, CheckCircle } from "lucide-react";

export default function SelectRole() {
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleSubmit = async () => {
    if (!selected) return;
    setLoading(true);
    try {
      const res = await setRole(selected);
      setUser(res.data);
      // Use window.location for clean redirect after role set
      window.location.href = selected === "landlord" ? "/landlord-dashboard" : "/dashboard";
    } catch (err) {
      console.error("Role selection error:", err);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: "#faf8f3" }}>
      <div className="max-w-lg w-full">
        <h1 data-testid="select-role-heading" className="text-4xl sm:text-5xl font-bold text-[#0d0d0d] mb-3 font-['Fraunces']">
          Welcome to LowKey
        </h1>
        <p className="text-[#5a5a5a] mb-10 text-lg">How will you use the platform?</p>
        <div className="space-y-4">
          <button
            data-testid="role-renter-btn"
            onClick={() => setSelected("renter")}
            className={`w-full p-6 rounded-2xl border-2 text-left transition-all flex items-center gap-4 ${
              selected === "renter"
                ? "border-[#1a6b3c] bg-white shadow-lg"
                : "border-[#d5d3ce] bg-white/60 hover:border-[#1a6b3c]/40"
            }`}
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${selected === "renter" ? "bg-[#1a6b3c]" : "bg-[#e5e3de]"}`}>
              <Home className={`w-6 h-6 ${selected === "renter" ? "text-white" : "text-[#5a5a5a]"}`} />
            </div>
            <div className="flex-1">
              <p className="font-semibold text-lg text-[#0d0d0d]">I Need a Place</p>
              <p className="text-sm text-[#5a5a5a]">Browse listings, apply, and find your next home</p>
            </div>
            {selected === "renter" && <CheckCircle className="w-6 h-6 text-[#1a6b3c]" />}
          </button>

          <button
            data-testid="role-landlord-btn"
            onClick={() => setSelected("landlord")}
            className={`w-full p-6 rounded-2xl border-2 text-left transition-all flex items-center gap-4 ${
              selected === "landlord"
                ? "border-[#1a6b3c] bg-white shadow-lg"
                : "border-[#d5d3ce] bg-white/60 hover:border-[#1a6b3c]/40"
            }`}
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${selected === "landlord" ? "bg-[#1a6b3c]" : "bg-[#e5e3de]"}`}>
              <Building className={`w-6 h-6 ${selected === "landlord" ? "text-white" : "text-[#5a5a5a]"}`} />
            </div>
            <div className="flex-1">
              <p className="font-semibold text-lg text-[#0d0d0d]">I Have a Place to List</p>
              <p className="text-sm text-[#5a5a5a]">Post listings, screen renters, manage properties</p>
            </div>
            {selected === "landlord" && <CheckCircle className="w-6 h-6 text-[#1a6b3c]" />}
          </button>
        </div>

        <Button
          data-testid="continue-role-btn"
          onClick={handleSubmit}
          disabled={!selected || loading}
          className="w-full mt-8 h-14 rounded-full text-lg font-semibold bg-[#c8f563] text-[#0d0d0d] hover:bg-[#b8e553] disabled:opacity-40"
        >
          {loading ? "Setting up..." : "Continue"}
        </Button>
      </div>
    </div>
  );
}
